export default __webpack_public_path__ + "static/media/NewTable.91b460e9.png";